export const messages = {
  en: {
    stockUpStoreOrder: {
      title: 'Order Stock Up',
      orderInfo: 'Order Information',
      orderId: 'Order ID',
      totalAmount: 'Total Amount',
      orderTime: 'Order Time',
      user: 'User',
      profitSharing: 'Profit Sharing',
      platform: 'Platform',
      productInfo: 'Product Information',
      productImage: 'Product Image',
      productName: 'Product Name',
      productId: 'Product ID',
      quantity: 'Quantity',
      paymentAmount: 'Payment Amount',
      status: 'Status',
      paymentTime: 'Payment Time',
      remark: 'Remark',
      writeOffNum: 'Write Off Number',
      stockUpRemark: 'Stock Up Remark',
      finishStockUp: 'Finish Stock Up',
      back: 'Back',
      requiredWriteOffNum: 'Write off number is required',
      selectProducts: 'Please select products'
    }
  },
  zh: {
    stockUpStoreOrder: {
      title: '订单备货',
      orderInfo: '订单信息',
      orderId: '订单编码',
      totalAmount: '总金额',
      orderTime: '下单时间',
      user: '用户',
      profitSharing: '是否分账',
      platform: '平台',
      productInfo: '商品信息',
      productImage: '商品图片',
      productName: '商品名称',
      productId: '商品编号',
      quantity: '数量',
      paymentAmount: '支付金额',
      status: '状态',
      paymentTime: '支付时间',
      remark: '说明',
      writeOffNum: '核销单号',
      stockUpRemark: '备货说明',
      finishStockUp: '备货完成',
      back: '返回',
      requiredWriteOffNum: '请填写核销单号',
      selectProducts: '请选择商品'
    }
  }
}